import React from 'react';
import { __rest } from '../../_virtual/_tslib.js';
import DateQuestion from './DateQuestion/index.js';
import InputTextQuestion from './InputTextQuestion/index.js';
import ListQuestion from './ListQuestion/index.js';
import NumericQuestion from './NumericQuestion/index.js';

var Question = function Question(_a) {
  var question = _a.question,
      rest = __rest(_a, ["question"]);

  switch (question.__typename) {
    case 'DateQuestionPathNodeFlowViewModel':
      return React.createElement(DateQuestion, Object.assign({
        question: question
      }, rest));

    case 'InputTextQuestionPathNodeFlowViewModel':
      return React.createElement(InputTextQuestion, Object.assign({
        question: question
      }, rest));

    case 'ListQuestionPathNodeFlowViewModel':
      return React.createElement(ListQuestion, Object.assign({
        question: question
      }, rest));

    case 'NumericQuestionPathNodeFlowViewModel':
      return React.createElement(NumericQuestion, Object.assign({
        question: question
      }, rest));

    default:
      return null;
  }
};

export default Question;
//# sourceMappingURL=index.js.map
